module.exports = __webpack_public_path__ + "03_glasses_red.a40ecdbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer4/03_glasses_red.png
// module id = ztVR
// module chunks = 0